import { jsx as y } from "react/jsx-runtime";
import { createContext as b, useRef as l, useMemo as v, useEffect as h, useState as k, useContext as P, useCallback as x } from "react";
import { i as j, C as p, d as q } from "./index-CCtUt9Tt.js";
function E(e) {
  const r = l(e), t = l(0);
  return j(e, r.current) || (r.current = e, t.current += 1), v(() => r.current, [t.current]);
}
function L(e, r) {
  return h(e, E(r));
}
const C = b(null);
function R({
  children: e,
  locale: r,
  space: t,
  environment: s,
  debugMode: u = !1,
  enableInspectorMode: i = !0,
  enableLiveUpdates: f = !0,
  targetOrigin: o,
  experimental: n
}) {
  if (!r)
    throw new Error(
      'ContentfulLivePreviewProvider has to be called with a locale property (for example: `<ContentfulLivePreviewProvider locale="en-US">{children}</ContentfulLivePreviewProvider>`'
    );
  p.init({
    locale: r,
    space: t,
    environment: s,
    debugMode: u,
    enableInspectorMode: i,
    enableLiveUpdates: f,
    targetOrigin: o,
    experimental: n
  });
  const c = v(
    () => ({
      locale: r,
      space: t,
      environment: s,
      debugMode: u,
      enableInspectorMode: i,
      enableLiveUpdates: f,
      targetOrigin: o
    }),
    [r, t, s, u, i, f, o]
  );
  return /* @__PURE__ */ y(C.Provider, { value: c, children: e });
}
function a(e, r, t = !1) {
  const [s, u] = k({ data: e, version: 1 }), i = l(e), f = l(q(u)), o = P(C), n = typeof r == "object" ? r : { locale: r, skip: t }, c = v(() => o && !o.enableLiveUpdates || n.skip ? !1 : !!(Array.isArray(e) && e.length || e && typeof e == "object" && Object.keys(e).length), [o, n.skip, e]);
  return L(() => {
    if (i.current !== e && (u({ data: e, version: 1 }), i.current = e), !!c)
      return p.subscribe("edit", {
        data: e,
        locale: n.locale,
        query: n.query,
        callback: (m) => {
          f.current((w) => ({ data: m, version: w.version + 1 }));
        }
      });
  }, [e, c, n.locale, n.query]), s.data;
}
function z(e) {
  const r = P(C);
  return x(
    (t) => r?.enableInspectorMode ? p.getProps({ ...e, ...t }) : null,
    [r?.enableInspectorMode, e]
  );
}
export {
  R as ContentfulLivePreviewProvider,
  z as useContentfulInspectorMode,
  a as useContentfulLiveUpdates,
  L as useDeepCompareEffectNoCheck,
  E as useDeepCompareMemoize
};
//# sourceMappingURL=react.js.map
